module.exports = __webpack_public_path__ + "static/media/webtunes_vol3.82c9d398.png";